export const createWalletUrl = (base, path) => {
    // Ensure base ends with '/' to avoid URL treating it like a file
    const normalizedBase = base.endsWith("/") ? base : base + "/";
    const normalizedPath = path.startsWith("/") ? path.slice(1) : path;
    return new URL(normalizedPath, normalizedBase);
};
//# sourceMappingURL=createWalletUrl.js.map